import { validateDefinition, validateSubmission, validateCancellation } from "./validate";
var BackgroundTasks = Object.freeze({
  defineTask: function defineTask(identifier, handler) {
    validateDefinition(identifier, handler);
    return function() {
    };
  },
  submit: function submit(identifier) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    validateSubmission(identifier, options.earliestBeginDateMs);
    return Promise.resolve();
  },
  getPending: function getPending() {
    return Promise.resolve([]);
  },
  cancel: function cancel(identifier) {
    validateCancellation(identifier);
  }
});
export {
  BackgroundTasks
};
//# sourceMappingURL=unavailable.js.map
